import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Auth } from './auth';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

const client = axios.create({
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
});

axiosRetry(client, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

async function getAuthHeaders() {
  const accessToken = Auth.getAccessToken();
  if (!accessToken) return;
  return { Authorization: `Bearer ${accessToken}` }
}

const HTTP = {
  get: async (request) => {
    const authHeaders = await getAuthHeaders(request.accessToken);
    return await client({
        method: 'get',
        url: request.path,
        headers: { ...request.headers, ...authHeaders },
    });
  },
  post: async (request) => {
    const authHeaders = await getAuthHeaders(request.accessToken);
    return await client({
        method: 'post',
        url: request.path,
        data: request.data,
        headers: { ...request.headers, ...authHeaders },
    });
  },
  delete: async (request) => {
    const authHeaders = await getAuthHeaders(request.accessToken);
    return await client({
        method: 'delete',
        url: request.path,
        headers: { ...request.headers, ...authHeaders },
    });
  },
};

const refreshToken = async (failedRequest) => {
  try {
    const { accessToken, error, message } = await Auth.refreshAccessToken();
    if (!accessToken || error) {
      window.location.reload();
    }
    // eslint-disable-next-line no-param-reassign, dot-notation
    failedRequest.response.config.headers['Authorization'] = `Bearer ${accessToken}`;
    return Promise.resolve({ accessToken, error, message });
  } catch (error) {
    window.location.reload();
  }
};

createAuthRefreshInterceptor(client, refreshToken);

export { HTTP };
